export default "__VITE_PUBLIC_ASSET__b912431e__"